var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5C14.3764 0.5 15.9252 1.73358 16.4217 3.99953L22.5 4C23.0523 4 23.5 4.44772 23.5 5C23.5 5.55228 23.0523 6 22.5 6H21.395L19.7827 21.3141C19.622 22.8409 18.3345 24 16.7992 24H7.20079C5.66551 24 4.37799 22.8409 4.21727 21.3141L2.605 6H1.5C0.947715 6 0.5 5.55228 0.5 5C0.5 4.44772 0.947715 4 1.5 4L7.57826 3.99953C8.07482 1.73358 9.62365 0.5 12 0.5ZM19.383 6H4.616L6.20628 21.1047C6.25985 21.6136 6.68903 22 7.20079 22H16.7992C17.311 22 17.7401 21.6136 17.7937 21.1047L19.383 6ZM12 10C12.5523 10 13 10.4477 13 11V16.5C13 17.0523 12.5523 17.5 12 17.5C11.4477 17.5 11 17.0523 11 16.5V11C11 10.4477 11.4477 10 12 10ZM12 2.5C10.7333 2.5 10.0003 2.95411 9.64783 3.99956H14.3522C13.9997 2.95411 13.2667 2.5 12 2.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.bebfc8ddef51d421b527cb0893e80224.svg";
export { ForwardRef as ReactComponent };